/** @type {import('./$types').PageLoad} */
import { createCustomerClient } from '$lib/utils/shopify/customer';
import { query as customerOrders } from '$lib/utils/shopify/queries/customerOrders';

export async function load({ url, fetch }) {
    const customerClient = createCustomerClient(fetch);

    const { searchParams } = url;
    const recordsToReturn = 10;

    const defaultPaginator = { first: null, before: null, last: null, after: null };
    const paginatorOptions = {};
    if (searchParams.get('after')) {
        paginatorOptions.first = recordsToReturn;
        paginatorOptions.after = searchParams.get('after');
    } else if (searchParams.get('before')) {
        paginatorOptions.last = recordsToReturn;
        paginatorOptions.before = searchParams.get('before');
    } else {
        paginatorOptions.first = recordsToReturn;
    }
    const paginator = { ...defaultPaginator, ...paginatorOptions };

    // shopify
    let { data, errors } = await customerClient.query({
        query: customerOrders,
        variables: { ...paginator }
    });

    return { ...data, errors };
}
